export default __webpack_public_path__ + "2671b47811bbff54bc7319efc456721d.webp";